module.exports = __webpack_public_path__ + "img/pix.0e5ced65.svg";